
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { CreateElement } from "vue";
import {
  ICProdProvider,
  ICProdProviderMethods
} from "@/models/providers/contractProduct";

@Component
export default class CProdModifyLink extends Vue {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => ICProdProvider;

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: ICProdProviderMethods;

  // Props

  @Prop({ default: () => ({}) })
  public tooltip!: Record<string, any>;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  // Render

  public render(h: CreateElement) {
    if (!this.cProdData.canModifyBilling)
      return this.$scopedSlots.default && this.$scopedSlots.default({});
    return h("b-tooltip", {
      props: {
        label: this.$t("_sentence.cprod.modify_link_tooltip"),
        multilined: true,

        ...this.tooltip
      },
      scopedSlots: {
        default: () =>
          h("u-link", {
            props: this.$attrs,
            on: {
              click: this.$cProdMethods.openModifyProductModal
            },
            scopedSlots: {
              default: this.$scopedSlots.default
            }
          })
      }
    });
  }
}
